module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += 'javascript:(function() {\n\nif (window.location.host === \'' +
__e( mosaikHost ) +
'\') {\nalert(\'' +
__e( warning ) +
'\');\nreturn;\n}\n\nvar script = document.createElement(\'script\');\nscript.setAttribute(\'src\', window.location.protocol + \'//' +
__e( mosaikHost ) +
'' +
__e( channelUrl ) +
'\');\nscript.setAttribute(\'data-channel\', \'' +
__e( id ) +
'\');\nscript.setAttribute(\'data-preview\', \'' +
__e( version ) +
'\');\n\ndocument.head.appendChild(script);\n\n})();';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/publish/channelSetup/ChannelBookmarklet.tpl
// module id = 2836
// module chunks = 0